import { isNonEmptyArray, isNonEmptyDateRange } from './commons';

const getFilterCount = (panelFilters = {}) => {
  const { createdAt, createdBy, updatedAt, updatedBy } = panelFilters;
  let count = 0;

  if (isNonEmptyArray(createdBy)) {
    count += 1;
  }

  if (isNonEmptyDateRange(createdAt)) {
    count += 1;
  }

  if (isNonEmptyArray(updatedBy)) {
    count += 1;
  }

  if (isNonEmptyDateRange(updatedAt)) {
    count += 1;
  }

  return count;
};

export default getFilterCount;
